export enum ThemesNames {
    LightTheme = 'LightTheme',
    DarkTheme = 'DarkTheme',
}
